import React from 'react';
import { useNotFound } from '../hooks/useNotFound';

const NotFoundContainer = () => {
	const { blockClass, componentId } = useNotFound();
	const prefix = 'vtex-search-result-3-x';
	const renderBlockClass = (suffix: string) => {
		return `${blockClass ? `${suffix}--${blockClass} ${prefix}-${suffix}--${blockClass}` : ''} ${suffix} ${prefix}-${suffix}`;
	};

	return (
		<div
			data-selection={componentId}
			className={`${renderBlockClass('searchNotFound')} flex flex-column-s flex-row-ns justify-center-ns items-center h-auto-s h5-ns`}
		>
			<div
				className={`${renderBlockClass('searchNotFoundOops')} flex justify-end-ns justify-center-s ttu f1 ph4 pv4-s pv0-ns c-muted-3 ph9 b`}
			>
				oops!
			</div>
			<div className={`${renderBlockClass('searchNotFoundInfo')} flex flex-column ph9`}>
				Nenhum produto foi encontrado
				<p className={`${renderBlockClass('searchNotFoundWhatDoIDo')} c-muted-2`}>O que eu faço?</p>
				<ul className={`${renderBlockClass('searchNotFoundWhatToDoDots')} c-muted-2`}>
					<li className={`${renderBlockClass('searchNotFoundWhatToDoDots')}`}>Verifique os termos digitados.</li>
					<li className={`${renderBlockClass('searchNotFoundWhatToDoDots')}`}>Tente utilizar uma única palavra.</li>
					<li className={`${renderBlockClass('searchNotFoundWhatToDoDots')}`}>Utilize termos genéricos na busca.</li>
					<li className={`${renderBlockClass('searchNotFoundWhatToDoDots')}`}>
						Procure utilizar sinônimos ao termo desejado.
					</li>
				</ul>
			</div>
		</div>
	);
};

export default NotFoundContainer;
